/* BYŪTI utkast 3: header, megamenyer, nedtelling, kurvskuff og de interaktive seksjonene. */
(() => {
  if (window.__b3) return;
  window.__b3 = true;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const kr = (oere) => new Intl.NumberFormat('nb-NO', { minimumFractionDigits: oere % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(oere / 100) + ' kr';
  const FRI_FRAKT = 300000;

  function toast(t) {
    let e = $('.b3-toast');
    if (!e) { e = document.createElement('div'); e.className = 'b3-toast'; e.setAttribute('role', 'status'); document.body.appendChild(e); }
    e.textContent = t; e.classList.add('b3-vis'); clearTimeout(e._t); e._t = setTimeout(() => e.classList.remove('b3-vis'), 2400);
  }
  window.b3Toast = toast;

  /* ── Levering samme dag ── */
  const DAGER = ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'];
  function levering() {
    const n = new Date(), d = n.getDay(), frist = new Date(n); frist.setHours(11, 0, 0, 0);
    if (d >= 1 && d <= 5 && n < frist) {
      const min = Math.ceil((frist - n) / 60000), t = Math.floor(min / 60), m = min % 60;
      return { kort: 'Sendes i dag', lang: `Bestill innen <b>${t ? t + ' t ' : ''}${m} min</b>, så sender vi i dag` };
    }
    const neste = new Date(n); do { neste.setDate(neste.getDate() + 1); } while (neste.getDay() === 0 || neste.getDay() === 6);
    const imorgen = neste.getDay() === (d + 1) % 7 && neste - n < 2 * 864e5;
    const navn = imorgen ? 'i morgen' : 'på ' + DAGER[neste.getDay()];
    return { kort: 'Sendes ' + navn, lang: `Bestill nå, så sender vi <b>${navn}</b>` };
  }
  function oppdaterLevering() {
    const l = levering();
    $$('[data-b3-levering]').forEach((e) => { e.innerHTML = l.lang; });
    $$('[data-b3-levering-ren]').forEach((e) => { e.textContent = l.lang.replace(/<\/?b>/g, ''); });
  }
  setInterval(oppdaterLevering, 30000);

  /* ── Header: megamenyer, mobilmeny og konto ── */
  let megaTid;
  function apneMega(navn) {
    clearTimeout(megaTid);
    $$('.b3-mega').forEach((m) => m.classList.toggle('b3-apen', m.dataset.mega === navn));
    $$('[data-b3-mega]').forEach((a) => a.classList.toggle('b3-paa', a.dataset.b3Mega === navn));
  }
  function lukkMega(straks) {
    const lukk = () => { $$('.b3-mega').forEach((m) => m.classList.remove('b3-apen')); $$('[data-b3-mega]').forEach((a) => a.classList.remove('b3-paa')); };
    if (straks) lukk(); else megaTid = setTimeout(lukk, 160);
  }
  document.addEventListener('mouseover', (e) => {
    if (innerWidth <= 860) return;
    const u = e.target.closest('[data-b3-mega]');
    if (u) { apneMega(u.dataset.b3Mega); return; }
    const m = e.target.closest('.b3-mega');
    if (m) {
      clearTimeout(megaTid);
      const valg = e.target.closest('[data-b3-merke]');
      if (valg) {
        const id = valg.dataset.b3Merke;
        $$('[data-b3-merke]', m).forEach((a) => a.classList.toggle('b3-paa', a === valg));
        $$('.b3-mpanel', m).forEach((p) => p.classList.toggle('b3-paa', p.dataset.panel === id));
      }
      return;
    }
    if (!e.target.closest('.b3-meny')) lukkMega();
  });
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-b3-burger]')) { $('.b3-mobilmeny')?.classList.toggle('b3-apen'); return; }
    const k = e.target.closest('[data-b3-konto]');
    if (k) { k.closest('.b3-konto').classList.toggle('b3-apen'); return; }
    if (!e.target.closest('.b3-kontomeny')) $$('.b3-konto').forEach((x) => x.classList.remove('b3-apen'));
    if (e.target.closest('.b3-mega a')) lukkMega(true);
  });

  /* ── Kurvskuff (Shopify cart API) ── */
  let kurv = null;
  async function hentKurv() { kurv = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json()); tegnKurv(); return kurv; }
  function tegnKurv() {
    if (!kurv) return;
    $$('[data-b3-kurvantall]').forEach((e) => { e.textContent = kurv.item_count; });
    const panel = $('#b3-skuff'); if (!panel) return;
    const sum = kurv.items_subtotal_price, igjen = FRI_FRAKT - sum;
    $('[data-b3-frakt]', panel).innerHTML = (igjen > 0 ? `Handle for <b>${kr(igjen)}</b> til, så er frakten gratis` : '<span style="color:var(--b3-gronn)">✓ Du har fri frakt</span>') +
      `<div class="b3-linje"><i style="width:${Math.min(100, sum / FRI_FRAKT * 100)}%"></i></div>`;
    $('[data-b3-varer]', panel).innerHTML = kurv.items.length ? kurv.items.map((i) => `<div class="b3-kv">
      <span class="b3-b">${i.image ? `<img src="${esc(i.image)}&width=160" alt="">` : ''}</span>
      <div><b>${esc(i.product_title)}</b><small>${esc(i.variant_title || '')}${i.sku ? ' · ' + esc(i.sku) : ''}</small><br>
        <span class="b3-ant"><button data-b3-endre="${i.key}" data-n="${i.quantity - 1}" aria-label="Færre">−</button><span>${i.quantity}</span><button data-b3-endre="${i.key}" data-n="${i.quantity + 1}" aria-label="Flere">+</button></span></div>
      <div class="b3-sum">${kr(i.final_line_price)}<a href="#" class="b3-fjern" data-b3-endre="${i.key}" data-n="0">Fjern</a></div></div>`).join('')
      : '<div class="b3-tom">Kurven er tom.</div>';
    $('[data-b3-bunn]', panel).innerHTML = kurv.items.length ? `<div class="b3-r"><span>Varer</span><span>${kr(sum)}</span></div>
      <div class="b3-r"><span>Frakt</span><span>${igjen > 0 ? 'Beregnes i kassen' : 'Gratis'}</span></div>
      <div class="b3-r b3-total"><span>Sum</span><span>${kr(kurv.total_price)}</span></div>
      <a class="b3-knapp" href="/checkout">Til kassen</a><div class="b3-info">${levering().kort} · Kort eller Svea faktura</div>` : '';
  }
  function apneSkuff() { const s = $('#b3-skuff'); if (!s) { location.href = '/cart'; return; } s.hidden = false; hentKurv(); }
  window.b3ApneSkuff = apneSkuff;
  document.addEventListener('click', async (e) => {
    if (e.target.closest('[data-b3-apneskuff]')) { e.preventDefault(); apneSkuff(); return; }
    if (e.target.closest('[data-b3-lukkskuff]')) { $('#b3-skuff').hidden = true; return; }
    const en = e.target.closest('[data-b3-endre]');
    if (en) {
      e.preventDefault();
      kurv = await fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: en.dataset.b3Endre, quantity: +en.dataset.n }) }).then((r) => r.json());
      tegnKurv();
      document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: kurv }, bubbles: true }));
    }
  });
  document.addEventListener('theme:cart:change', (e) => {
    if (e.detail && e.detail.cart) { kurv = e.detail.cart; tegnKurv(); }
    $$('.b3-ikon[data-b3-apneskuff]').forEach((k) => { k.classList.remove('b3-hopp'); void k.offsetWidth; k.classList.add('b3-hopp'); });
  });
  async function leggI(varianter) {
    const r = await fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: varianter }) });
    const d = await r.json();
    if (!r.ok) throw new Error(d.description || 'Kunne ikke legge i kurven');
    const cart = await hentKurv();
    document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart }, bubbles: true }));
    return cart;
  }
  window.b3LeggI = leggI;

  /* ── Forside: kundetyper, slider og kursdag ── */
  document.addEventListener('click', (e) => {
    const f = e.target.closest('[data-b3-fane]');
    if (f) {
      const rot = f.closest('[data-b3-faner]');
      $$('[data-b3-fane]', rot).forEach((b) => b.classList.toggle('b3-paa', b === f));
      $$('[data-b3-panel]', rot).forEach((p) => p.classList.toggle('b3-paa', p.dataset.b3Panel === f.dataset.b3Fane));
    }
    const s = e.target.closest('[data-b3-slide]');
    if (s) { const sl = $('.b3-slider', s.closest('section')); sl.scrollBy({ left: +s.dataset.b3Slide * sl.clientWidth * 0.8, behavior: 'smooth' }); }
    const h = e.target.closest('[data-b3-hurtig]');
    if (h && window.byutiSok) window.byutiSok.aapne(h.dataset.b3Hurtig);
  });
  let ned = null, x0 = 0, s0 = 0, flyttet = false;
  document.addEventListener('pointerdown', (e) => { const sl = e.target.closest('.b3-slider'); if (!sl || e.pointerType !== 'mouse') return; ned = sl; flyttet = false; x0 = e.clientX; s0 = sl.scrollLeft; });
  document.addEventListener('pointermove', (e) => { if (!ned) return; const d = e.clientX - x0; if (Math.abs(d) > 5) { flyttet = true; ned.classList.add('b3-drar'); } ned.scrollLeft = s0 - d; });
  document.addEventListener('pointerup', () => { if (!ned) return; const sl = ned; ned = null; setTimeout(() => sl.classList.remove('b3-drar'), 0); });
  document.addEventListener('click', (e) => { if (flyttet && e.target.closest('.b3-slider')) { e.preventDefault(); e.stopImmediatePropagation(); flyttet = false; } }, true);
  document.addEventListener('scroll', (e) => {
    const sl = e.target; if (!sl.classList || !sl.classList.contains('b3-slider')) return;
    const f = $('.b3-fremdrift span', sl.closest('section')); if (!f) return;
    const andel = sl.clientWidth / sl.scrollWidth, maks = sl.scrollWidth - sl.clientWidth;
    f.style.width = andel * 100 + '%'; f.style.transform = `translateX(${maks ? (sl.scrollLeft / maks) * ((1 - andel) / andel) * 100 : 0}%)`;
  }, true);
  function kursdag() {
    $$('.b3-kursdag').forEach((rot) => {
      const steg = $$('.b3-ksteg', rot), bilder = $$('.b3-kursdag__bilde img', rot);
      const obs = new IntersectionObserver((inn) => inn.forEach((e) => {
        if (!e.isIntersecting) return;
        const i = steg.indexOf(e.target);
        steg.forEach((s, j) => s.classList.toggle('b3-paa', i === j));
        bilder.forEach((b, j) => b.classList.toggle('b3-paa', i === j));
      }), { rootMargin: '-45% 0px -45% 0px' });
      steg.forEach((s) => obs.observe(s));
    });
  }

  /* ── Kursdatoer: sorter og vis de neste ── */
  const MND = { januar: 0, februar: 1, mars: 2, april: 3, mai: 4, juni: 5, juli: 6, august: 7, september: 8, oktober: 9, november: 10, desember: 11 };
  const KM = ['jan.', 'feb.', 'mars', 'april', 'mai', 'juni', 'juli', 'aug.', 'sep.', 'okt.', 'nov.', 'des.'];
  const tilDato = (t) => { const m = /(\d+)\.\s*([a-zæøå]+)\s+(\d{4})/i.exec(t || ''); return m ? new Date(+m[3], MND[m[2].toLowerCase()] ?? 0, +m[1]) : null; };
  function nesteKurs() {
    $$('[data-b3-nestekurs]').forEach((rot) => {
      const maks = +rot.dataset.b3Nestekurs || 3;
      const rader = $$('[data-dato]', rot).map((a) => ({ a, d: tilDato(a.dataset.dato) })).filter((x) => x.d && x.d >= new Date(new Date().toDateString()));
      rader.sort((x, y) => x.d - y.d);
      rot.innerHTML = '';
      rader.slice(0, maks).forEach(({ a, d }) => { const dag = $('[data-dag]', a); if (dag) dag.textContent = d.getDate() + '. ' + KM[d.getMonth()]; rot.appendChild(a); });
      rot.hidden = false;
    });
  }

  /* ── Akademiet: filtre, aapne kurs, velg dato og meld paa ── */
  function kursliste() {
    $$('[data-b3-kursliste]').forEach((rot) => {
      let fag = 'alle', mnd = 'alle';
      const kurs = $$('.b3-kr', rot);
      kurs.forEach((k) => {
        const ds = $$('[data-variant]', k).map((b) => tilDato(b.dataset.dato)).filter(Boolean);
        k._datoer = ds; k._forste = ds.length ? Math.min(...ds) : 9e15;
        const forste = $('.b3-kr__dato', k);
        if (forste && ds.length) { const d = new Date(k._forste); forste.innerHTML = `<b>${d.getDate()}. ${KM[d.getMonth()]}</b><small>${ds.length > 1 ? '+ ' + (ds.length - 1) + ' datoer til' : 'Neste kurs'}</small>`; }
      });
      kurs.forEach((k) => {
        $$('[data-variant]', k).forEach((b) => { const d = tilDato(b.dataset.dato); if (d) { b.innerHTML = `<b>${d.getDate()}. ${KM[d.getMonth()]}</b><small>${d.getFullYear()}</small>`; b.dataset.kort = d.getDate() + '. ' + KM[d.getMonth()]; } });
        const v = $('[data-variant].b3-valgt', k), m = $('.b3-kr__meld', k); if (v && m) m.textContent = 'Meld deg på ' + v.dataset.kort;
      });
      kurs.sort((a, b) => a._forste - b._forste).forEach((k) => $('.b3-kursliste', rot).appendChild(k));
      const mnder = [...new Set(kurs.flatMap((k) => k._datoer.map((d) => d.getFullYear() * 100 + d.getMonth())))].sort();
      const fagene = [...new Set(kurs.map((k) => k.dataset.fag))];
      const tegnVelgere = () => {
        $('[data-b3-fagvelger]', rot).innerHTML = ['alle', ...fagene].map((f) => `<button data-b3-fag="${esc(f)}" class="${f === fag ? 'b3-paa' : ''}">${f === 'alle' ? 'Alle fag' : esc(f)}</button>`).join('');
        $('[data-b3-mndvelger]', rot).innerHTML = ['alle', ...mnder].map((m) => `<button data-b3-mnd="${m}" class="${String(m) === String(mnd) ? 'b3-paa' : ''}">${m === 'alle' ? 'Alle måneder' : KM[m % 100].replace('.', '') + ' ' + Math.floor(m / 100)}</button>`).join('');
      };
      const filtrer = () => {
        let n = 0;
        kurs.forEach((k) => {
          const ok = (fag === 'alle' || k.dataset.fag === fag) && (mnd === 'alle' || k._datoer.some((d) => d.getFullYear() * 100 + d.getMonth() === +mnd));
          k.hidden = !ok; if (ok) n++;
        });
        const a = $('[data-b3-kursantall]', rot); if (a) a.textContent = n + ' kurs passer valget';
        tegnVelgere();
      };
      rot.addEventListener('click', async (e) => {
        const f = e.target.closest('[data-b3-fag]'); if (f) { fag = f.dataset.b3Fag; filtrer(); return; }
        const m = e.target.closest('[data-b3-mnd]'); if (m) { mnd = m.dataset.b3Mnd; filtrer(); return; }
        const r = e.target.closest('.b3-kr__rad');
        if (r) { const k = r.closest('.b3-kr'), apen = !k.classList.contains('b3-apen'); kurs.forEach((x) => x.classList.remove('b3-apen')); if (apen) { k.classList.add('b3-apen'); setTimeout(() => k.scrollIntoView({ behavior: 'smooth', block: 'start' }), 60); } return; }
        const d = e.target.closest('[data-variant]');
        if (d) { const k = d.closest('.b3-kr'); $$('[data-variant]', k).forEach((b) => b.classList.toggle('b3-valgt', b === d)); $('.b3-kr__meld', k).textContent = 'Meld deg på ' + d.dataset.kort; return; }
        const meld = e.target.closest('.b3-kr__meld');
        if (meld) {
          const k = meld.closest('.b3-kr'), valgt = $('[data-variant].b3-valgt', k);
          if (!valgt) { location.href = meld.dataset.url; return; }
          meld.disabled = true;
          try { await leggI([{ id: +valgt.dataset.variant, quantity: 1 }]); apneSkuff(); } catch (err) { toast(err.message); }
          meld.disabled = false;
        }
      });
      filtrer();
    });
  }

  /* ── For merker: lanseringssteg ── */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-b3-lanser]'); if (!b) return;
    const rot = b.closest('.b3-lansering');
    $$('[data-b3-lanser]', rot).forEach((x) => x.classList.toggle('b3-paa', x === b));
    $$('.b3-lansering__vis', rot).forEach((v) => v.classList.toggle('b3-paa', v.dataset.steg === b.dataset.b3Lanser));
  });

  /* ── Varebestilling: soek i lista, varenummer og kjoept foer ── */
  function varebestilling() { $$('[data-b3-varebestilling]').forEach(enVarebestilling); }
  async function enVarebestilling(rot) {
    const inn = $('[data-b3-bsok]', rot), ut = $('[data-b3-btreff]', rot);
    /* Soekemotoren (byuti-sok.js) lastes etter dette skriptet. Vent paa den. */
    for (let i = 0; i < 50 && !(window.byutiSok && window.byutiSok.sok); i++) await new Promise((r) => setTimeout(r, 100));
    if (inn && ut && window.byutiSok && window.byutiSok.sok) {
      window.byutiSok.kobleKjop(ut);
      let t;
      rot.addEventListener('click', (e) => { const f = e.target.closest('[data-b3-forslag]'); if (!f) return; inn.value = f.dataset.b3Forslag; inn.dispatchEvent(new Event('input')); $$('[data-b3-forslag]', rot).forEach((b) => b.classList.toggle('b3-paa', b === f)); });
      inn.addEventListener('input', () => { clearTimeout(t); t = setTimeout(async () => {
        const q = inn.value.trim(); if (!q) { ut.innerHTML = ''; return; }
        await window.byutiSok.hentIndeks();
        const treff = window.byutiSok.sok(q);
        ut.innerHTML = treff.length ? window.byutiSok.listeHtml(treff, 15) : '<p class="b3-mut" style="padding:12px 0">Ingen treff. Prøv varenummeret.</p>';
      }, 120); });
    }
    rot.addEventListener('click', async (e) => {
      const p = e.target.closest('[data-b3-pm]');
      if (p) { const f = $('input', p.closest('.b3-ant2')); f.value = Math.max(1, (+f.value || 1) + (+p.dataset.b3Pm)); return; }
      const l = e.target.closest('[data-b3-leggi]');
      if (l) {
        const n = Math.max(1, +($('input', l.closest('.b3-kjop'))?.value || 1));
        l.disabled = true;
        try { await leggI([{ id: +l.dataset.b3Leggi, quantity: n }]); toast(n + ' × ' + l.dataset.navn + ' lagt i kurven'); } catch (err) { toast(err.message); }
        l.disabled = false; return;
      }
      if (e.target.closest('[data-b3-hele]')) {
        e.preventDefault();
        const v = $$('[data-b3-leggi]', rot).map((b) => ({ id: +b.dataset.b3Leggi, quantity: 1 }));
        const unike = [...new Map(v.map((x) => [x.id, x])).values()];
        try { await leggI(unike); apneSkuff(); } catch (err) { toast(err.message); }
        return;
      }
      if (e.target.closest('[data-b3-varenr]')) {
        const linjer = $('textarea', rot).value.split('\n').map((x) => x.trim()).filter(Boolean);
        if (!linjer.length || !window.byutiSok) return;
        const indeks = await window.byutiSok.hentIndeks();
        const varer = [], feil = [];
        linjer.forEach((linje) => {
          const [kode, ant] = linje.split(/\s+/);
          let funnet = null;
          for (const pr of indeks) { const v = pr.varianter.find((x) => x.sku.toLowerCase() === kode.toLowerCase() || String(x.strekkode) === kode); if (v && pr.tilgang) { funnet = v; break; } }
          if (funnet) varer.push({ id: funnet.id, quantity: Math.max(1, +ant || 1) }); else feil.push(kode);
        });
        if (varer.length) { try { await leggI(varer); apneSkuff(); } catch (err) { toast(err.message); } }
        toast(varer.length ? varer.length + ' varenumre lagt i kurven' + (feil.length ? '. Fant ikke: ' + feil.join(', ') : '') : 'Fant ingen av varenumrene');
      }
    });
  }

  /* ── For merker: skjema sendt ── */
  function skjema() {
    if (/contact_posted=true/.test(location.search)) $$('[data-b3-takk]').forEach((e) => { e.hidden = false; });
  }

  const start = () => { oppdaterLevering(); hentKurv(); kursdag(); nesteKurs(); kursliste(); varebestilling(); skjema(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', () => { kursdag(); nesteKurs(); kursliste(); oppdaterLevering(); });
})();

/* Kursgalleri: trykk på et bilde for å se det stort, piltaster blar */
(() => {
  let boks, bilder = [], nr = 0;
  const vis = () => { boks.querySelector('img').src = bilder[nr]; boks.querySelector('[data-teller]').textContent = (nr + 1) + ' / ' + bilder.length; };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-b3-storbilde]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (!boks) {
      boks = document.createElement('dialog'); boks.className = 'b3-lysboks';
      boks.innerHTML = '<img alt=""><div class="b3-lysboks__nav"><button type="button" data-f>← Forrige</button><span data-teller style="color:#fff;align-self:center;font-size:13px"></span><button type="button" data-n>Neste →</button><button type="button" data-l>Lukk ✕</button></div>';
      document.body.appendChild(boks);
      boks.addEventListener('click', (x) => {
        if (x.target === boks || x.target.closest('[data-l]')) boks.close();
        if (x.target.closest('[data-f]')) { nr = (nr - 1 + bilder.length) % bilder.length; vis(); }
        if (x.target.closest('[data-n]')) { nr = (nr + 1) % bilder.length; vis(); }
      });
      boks.addEventListener('keydown', (x) => {
        if (x.key === 'ArrowLeft') { nr = (nr - 1 + bilder.length) % bilder.length; vis(); }
        if (x.key === 'ArrowRight') { nr = (nr + 1) % bilder.length; vis(); }
      });
    }
    const alle = [...b.closest('.b3-kgalleri').querySelectorAll('[data-b3-storbilde]')];
    bilder = alle.map((x) => x.dataset.b3Storbilde); nr = alle.indexOf(b);
    vis(); boks.showModal();
  }, true);
})();

/* Megamenyen: produkttypene i merkepanelet byttes med gruppene merkesiden faktisk viser,
   hentet første gang panelet vises (samme data som merkesiden, så de ligger klare der) */
(() => {
  const fyll = (el) => {
    if (el.dataset.fylt || !window.btKort || !window.btKort.grupper) return;
    el.dataset.fylt = '1';
    window.btKort.grupper(el.dataset.b3Grupper).then((g) => {
      if (!g.length) return;
      el.innerHTML = g.slice(0, 8).map(([k, n]) => '<a href="' + el.dataset.url + '#gruppe=' + encodeURIComponent(k) + '">' + k.replace(/[&<>"]/g, '') + '</a>').join('');
    }).catch(() => { delete el.dataset.fylt; });
  };
  const sjekk = () => document.querySelectorAll('.b3-mpanel.b3-paa [data-b3-grupper]').forEach((el) => { if (el.offsetParent) fyll(el); });
  ['mouseover', 'focusin', 'click'].forEach((t) => document.addEventListener(t, (e) => {
    if (e.target.closest && e.target.closest('header, .b3-mega')) setTimeout(sjekk, 60);
  }, { passive: true }));
})();

/* Produktsiden: #varsle (fra «Varsle meg» på utsolgte kort) ruller til Omnisend-skjemaet «Gi meg beskjed» */
(() => {
  if (location.hash !== '#varsle') return;
  const t0 = Date.now();
  (function finn() {
    const el = document.querySelector('[id^="omnisend-embedded"], [id^="omnisend-form"]');
    if (el && el.offsetHeight) {
      window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 140, behavior: 'smooth' });
      const felt = el.querySelector('input[type=email], input');
      if (felt) setTimeout(() => felt.focus({ preventScroll: true }), 600);
    } else if (Date.now() - t0 < 8000) setTimeout(finn, 250);
  })();
})();

/* Liste eller ruter for produktkortene. Valget huskes i nettleseren; mobil starter med liste. */
(() => {
  const NOKKEL = 'bt-visning';
  let valg = null;
  try { valg = localStorage.getItem(NOKKEL); } catch (e) {}
  if (!valg) valg = window.matchMedia('(max-width: 760px)').matches ? 'liste' : 'ruter';
  const sett = (v) => {
    valg = v; document.documentElement.classList.toggle('bt-liste', v === 'liste');
    document.querySelectorAll('[data-bt-visning] button').forEach((b) => b.setAttribute('aria-pressed', b.dataset.v === v));
  };
  const ikon = { liste: '<svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h16M4 12h16M4 18h16" stroke="currentColor" stroke-width="1.6"/></svg>',
                 ruter: '<svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="4" width="7" height="7" fill="none" stroke="currentColor" stroke-width="1.6"/><rect x="13" y="4" width="7" height="7" fill="none" stroke="currentColor" stroke-width="1.6"/><rect x="4" y="13" width="7" height="7" fill="none" stroke="currentColor" stroke-width="1.6"/><rect x="13" y="13" width="7" height="7" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>' };
  const tegn = () => document.querySelectorAll('[data-bt-visning]:not([data-klar])').forEach((el) => {
    el.dataset.klar = '1'; el.classList.add('bt-visning');
    el.innerHTML = ['ruter', 'liste'].map((v) => '<button type="button" data-v="' + v + '" aria-label="' + (v === 'liste' ? 'Vis som liste' : 'Vis som ruter') + '" title="' + (v === 'liste' ? 'Liste' : 'Ruter') + '">' + ikon[v] + '</button>').join('');
  });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-bt-visning] button'); if (!b) return;
    e.preventDefault(); sett(b.dataset.v); try { localStorage.setItem(NOKKEL, b.dataset.v); } catch (x) {}
  });
  const start = () => { tegn(); sett(valg); };
  sett(valg);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
